export default __webpack_public_path__ + "static/media/May2011.7c9ace97.png";